import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Connection, WSNumber } from '../types/interfaces/connection.interface';
import { Observable } from 'rxjs';
import { ChannelConfigAttributes } from '../types/interfaces/channels';

@Injectable({
  providedIn: 'root',
})
export class ConnectionsService {
  constructor(private http: HttpClient) {}

  getConnection(id: number) {
    return this.http.get<ChannelConfigAttributes>(
      `${environment.apiHost}/connections/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  getConnections() {
    return this.http.get<ChannelConfigAttributes[]>(
      `${environment.apiHost}/connections`,
      {
        withCredentials: true,
      }
    );
  }

  createConnection(
    connection: ChannelConfigAttributes
  ): Observable<ChannelConfigAttributes> {
    return this.http.post<ChannelConfigAttributes>(
      `${environment.apiHost}/connections`,
      connection,
      {
        withCredentials: true,
      }
    );
  }

  updateConnection(
    connection: ChannelConfigAttributes
  ): Observable<ChannelConfigAttributes> {
    return this.http.put<ChannelConfigAttributes>(
      `${environment.apiHost}/connections/${connection.id}`,
      connection,
      {
        withCredentials: true,
      }
    );
  }

  deleteConnection(id: number): Observable<ChannelConfigAttributes> {
    return this.http.delete<ChannelConfigAttributes>(
      `${environment.apiHost}/connections/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  getWSAccountPhones(wsAccountId: string): Observable<WSNumber[]> {
    return this.http.get<WSNumber[]>(
      `${environment.apiHost}/connections/waba-phones/${wsAccountId}`,
      {
        withCredentials: true,
      }
    );
  }
}
